import React, { Component, Fragment } from 'react';
import { Layer, Stage } from 'react-konva';
import {  isDevelopment, matchesColors } from '../../../library/constants';
// import {  isEmptyObject } from '../../../library/calc';
import { NodeProfile } from '../../../components/Legend/nodeProfile';
import { translatedLabels } from '../../../library/constants';

export class Notifications extends NodeProfile {

  heightOfIconRow = 28;
  iconsLeftPadding = 15;
  iconsTopPadding = 10;

  state = {
    iconShowReady: false
  }

  componentDidMount(){

    this.buildIconHash();
    this.buildIconShow();
  }

  componentDidUpdate (prevProps, prevState, snapshot){

  }

  getMatchCountDescriptionTranslated({matchType, count}){
    const description = `{count} pending ${matchType} Matches`
    const translatedDescription = ( typeof(window.trl) !== 'undefined' ? window.trl(description, null, {count: count}): description);
    return translatedDescription;
  }

  buildIconShow(){

    const nodeObj = this.props.nodeObjs[this.props.nodeForFlipFocus];
    const prId = nodeObj.pr_id;
    const node = nodeObj.n;

    let cycleCount = 0;
    this.props.cidsGrps.forEach((cids)=>{
      if(cids.includes(node)){
        cycleCount = cids.length;
      }
    });

    // console.log(`nodeObj: `, JSON.stringify(nodeObj, null, 2));

    /*
      console.log(`nodeObj.sm: `, nodeObj.sm);
      console.log(`nodeObj.inc: `, nodeObj.inc);
      console.log(`nodeObj.m_p: `, nodeObj.m_p);
      console.log(`this.props.canShowCycleCount({nodeObj}): `, this.props.canShowCycleCount({nodeObj}));
      userTouchedNode({ node, callback, fromWhere })
     */

    this.iconShow = {
      'smartMatch': {
        show: typeof(nodeObj.sm) !== 'undefined' && parseInt(nodeObj.sm, 10) !== 0 ? true: false,
        description: this.getMatchCountDescriptionTranslated({matchType: 'Smart ', count: nodeObj.sm}),
        hasAction: true,
        action: () => {
          const href = `/fwd/myheritage?profile_id=${`prId`}&match_type=smart&src=canvas-tree&cmp=btn&trn=partner_Geni&trp=match_button_tree`;
          window.open(href, '_blank');
          return;
        },
        icon: <Fragment>

                {
                  this.getRectIcon({...this.iconHash.matchRect, ...{
                   left:  this.iconsLeftPadding - 3,
                   top: this.getTopIconPos({buffer: 3 }),
                   fill: matchesColors.smart }
                  })
                }

                {
                  this.getImgIcon({...this.iconHash.smartMatchSVG, ...{
                   left: this.iconsLeftPadding + 4, top: this.getTopIconPos({buffer: 7 }), }
                  })
                }


                {
                  this.getText_for_Icon({...this.iconHash.matchRect, ...{
                    textLeft: this.iconsLeftPadding + ( nodeObj.sm && nodeObj.sm.length > 1 ? 18: 22 ),
                    textTop: this.getTopIconPos({buffer: 8 }),
                    text: isDevelopment ? 99: nodeObj.sm, }
                  })
                }

              </Fragment>
      },
      'recordMatch': {
        show: typeof(nodeObj.rm) !== 'undefined' &&  parseInt(nodeObj.rm, 10) !== 0 ? true: false,
        // description: `${isDevelopment || typeof(nodeObj.rm) === 'undefined'? 0  : nodeObj.rm} Record Match`,
        description: this.getMatchCountDescriptionTranslated({matchType: 'Record ', count: nodeObj.rm}),
        hasAction: true,
        action: () => {
          const href = `/fwd/myheritage?profile_id=${prId}&match_type=record&src=canvas-tree&cmp=btn&trn=partner_Geni&trp=match_button_tree`;
          window.open(href, '_blank');
          return;
        },
        icon: <Fragment>

                {
                  this.getRectIcon({...this.iconHash.matchRect, ...{
                   left:  this.iconsLeftPadding - 3,
                   top: this.getTopIconPos({buffer: 3 }),
                   fill: matchesColors.record }
                  })
                }

                {
                  this.getImgIcon({...this.iconHash.recordMatchSVG, ...{
                   left: this.iconsLeftPadding + 4, top: this.getTopIconPos({buffer: 7 }), }
                  })
                }


                {
                  this.getText_for_Icon({...this.iconHash.matchRect, ...{
                    textLeft: this.iconsLeftPadding + ( nodeObj.rm && nodeObj.rm.length > 1 ? 18: 22 ),
                    textTop: this.getTopIconPos({buffer: 8 }),
                    text: isDevelopment ? 99: nodeObj.rm, }
                  })
                }

              </Fragment>
      },
      'geniMatch': {
        show: typeof(nodeObj.tm) !== 'undefined' &&   parseInt(nodeObj.tm, 10) !== 0 ? true: false,
        // description: `${isDevelopment || typeof(nodeObj.tm) === 'undefined'? 0 : nodeObj.tm} Tree Match`,
        description: this.getMatchCountDescriptionTranslated({matchType: 'Tree ', count: nodeObj.tm}),
        hasAction: true,
        action: () => {
          const href = `/search/matches?id=${prId}&src=canvas-tree&cmp=btn`;
          window.open(href, '_blank');
          return;
        },
        icon: <Fragment>

                {
                  this.getRectIcon({...this.iconHash.matchRect, ...{
                   left:  this.iconsLeftPadding - 3,
                   top: this.getTopIconPos({buffer: 3 }),
                   fill: matchesColors.tree }
                  })
                }

                {
                  this.getImgIcon({...this.iconHash.geniMatchSVG, ...{
                   left: this.iconsLeftPadding + 4, top: this.getTopIconPos({buffer: 7 }), }
                  })
                }


                {
                  this.getText_for_Icon({...this.iconHash.matchRect, ...{
                    textLeft: this.iconsLeftPadding + ( nodeObj.tm && nodeObj.tm.length > 1 ? 18: 22 ),
                    textTop: this.getTopIconPos({buffer: 8 }),
                    text: isDevelopment ? 99: nodeObj.tm, }
                  })
                }

              </Fragment>
      },
      'merge': {
        show: this.props.canShowPendingMerge({nodeObj}),
        description: translatedLabels['Pending merge'].translatedLabel,
        hasAction: true,
        action: () => {
          const href = '/merge/compare/' + prId;
          window.open(href, '_blank');
          return;
        },
        icon: <Fragment>


                {
                  this.getRectIcon({...this.iconHash.merge, ...{
                   left:  this.iconsLeftPadding + 4, top: this.getTopIconPos({buffer: 3 }), }
                  })
                }


                {
                  this.getText_for_Icon({...this.iconHash.merge, ...{
                    textLeft:  this.iconsLeftPadding + 10, textTop: this.getTopIconPos({buffer: 6 })}
                  })
                }

              </Fragment>
      },
      'inconsistency': {
        show: this.props.canShowInconsistency({nodeObj}),
        description: translatedLabels['Inconsistency'].translatedLabel,
        hasAction: true,
        action: () => {
            const href = '/inconsistencies/for_profile/' + prId;
            window.open(href, '_blank');
          return;
        },
        icon: <Fragment>

                          {
                            this.getRectIcon({...this.iconHash.inconsistency, ...{
                              left:  this.iconsLeftPadding + 4, top: this.getTopIconPos({buffer: 3 }),}
                            })
                          }


                          {
                            this.getText_for_Icon({...this.iconHash.inconsistency, ...{
                              textLeft: this.iconsLeftPadding + 12, textTop: this.getTopIconPos({buffer: 7 })}
                            })
                          }

                        </Fragment>
      },
      'dna':{
        show: this.props.hasDna({nodeObj}),
        description: translatedLabels['DNA Tested'].translatedLabel,
        hasAction: false,
        action: () => {
          return;
        },
        icon: <Fragment>

                        {
                          this.getRectIcon({...this.iconHash.dnaBlackBg, ...{
                                 left:  this.iconsLeftPadding + 2,
                                 top: this.getTopIconPos({buffer: 3 }) + 4,
                                 width: 27,
                                 height: 14,
                               }
                            })
                        }


                        {
                          this.getImgIcon({...this.iconHash.dna, ...{
                                 left: this.iconsLeftPadding + 2,
                                 top: this.getTopIconPos({buffer: 0 }) + 4,
                               }
                            })
                        }
                        </Fragment>
      },
      'conflict':{
        show: this.props.canShowResolveWarning({nodeObj}),
        description: translatedLabels['Tree conflict'].translatedLabel,
        hasAction: true,
        action: () => {
          this.props.fetchResolveAndPopModal({prId})
        },
        icon: <Fragment>

                        {
                          this.getImgIcon({...this.iconHash.conflict, ...{
                             left:  this.iconsLeftPadding + 4, top: this.getTopIconPos({buffer: 0 }), }
                            })
                        }
                        </Fragment>
      },
      'gedcom':{
        show: this.props.hasGedcom({nodeObj}),
        description: translatedLabels['GEDCOM import in progress'].translatedLabel,
        hasAction: false,
        action: () => {
          return;
        },
        icon: <Fragment>

                        {
                          this.getImgIcon({...this.iconHash.gedcom, ...{
                             left:  this.iconsLeftPadding  + 6,
                             top: this.getTopIconPos({buffer: 4 }),
                             width: 18,
                             height: 18,
                             }
                            })
                        }
                        </Fragment>
      },


      'cycle':{
        show: ( cycleCount > 0 ? true: false),
        description:  translatedLabels['Cycle Count'].translatedLabel,
        hasAction: false,
        action: () => {
          return;
        },
        icon:<Fragment>

                {
                  this.getRectIcon({...this.iconHash.cycle, ...{
                   left:  this.iconsLeftPadding + 4, top: this.getTopIconPos({buffer: 3 }), }
                  })
                }


                {
                  this.getText_for_Icon({...this.iconHash.cycle, ...{
                    textLeft:  this.iconsLeftPadding + 8, textTop: this.getTopIconPos({buffer: 8 })},
                    text: `x${cycleCount}`,
                  })
                }

              </Fragment>
      },


    }

    this.setState({iconShowReady: true})
  }

  getIcon({iconName}){
    return <tr onClick={() => { this.iconShow[iconName].action() }}  style={{border: '0px solid gray' }}>
            <td style={{
              width: `40px`,
              height: '35px',
              border: '0px solid gray',
              cursor: ( !this.iconShow[iconName].hasAction ? 'move': 'pointer'),
                        }}>
                    <Stage
                      width={50}
                      height={35}
                    >
                      <Layer>
                      {this.iconShow[iconName].icon}
                      </Layer>
                    </Stage>
            </td>
            <td style={{
                          fontSize: '13px',
                          color: '#636363',
                          border: '0px solid gray',
                          paddingLeft: '30px',
                          position: 'relative',
                          paddingTop: '10px',
                          fontWeight: 'bold',
                          textDecoration: ( !this.iconShow[iconName].hasAction ? 'none': 'underline'),
                          cursor: ( !this.iconShow[iconName].hasAction ? 'move': 'pointer'),
                        }}>{this.iconShow[iconName].description}
            </td>
          </tr>
  }


  getTopIconPos({buffer}){
    let iconTopPos = this.iconsTopPadding + 15 + buffer;
    iconTopPos -= 20
    return iconTopPos;
  }

  areAllShowPropertiesFalse() {
    return Object.keys(this.iconShow).every(key => !this.iconShow[key].show);
  }

  render () {
    if( typeof(this.iconShow) === 'undefined' ) return null;
    if( this.areAllShowPropertiesFalse()) return null;

    return (
        <Fragment>

        <div style={{
                width: `100%`,
                height: '25px',
                fontWeight: 'bold',
                fontSize: '15px',
                color: '#636363',
                textDecoration: 'underline',
                marginBottom: '10px',
              }}
        >Notifications
        </div>
            <table width='100%'><tbody>
                      {

                          // this.iconShow['match'].show ? this.getIcon({iconName: 'match'}): null
                       }


                      {

                          this.iconShow['smartMatch'].show ? this.getIcon({iconName: 'smartMatch'}): null
                       }


                      {

                          this.iconShow['recordMatch'].show ? this.getIcon({iconName: 'recordMatch'}): null
                       }


                      {

                          this.iconShow['geniMatch'].show ? this.getIcon({iconName: 'geniMatch'}): null
                       }


                      {

                          this.iconShow['merge'].show ? this.getIcon({iconName: 'merge'}): null
                      }
                      {

                          this.iconShow['inconsistency'].show ? this.getIcon({iconName: 'inconsistency'}): null
                      }
                      {

                          this.iconShow['dna'].show ? this.getIcon({iconName: 'dna'}): null
                      }

                      {

                          this.iconShow['gedcom'].show ? this.getIcon({iconName: 'gedcom'}): null
                      }


                      {

                          this.iconShow['conflict'].show ? this.getIcon({iconName: 'conflict'}): null
                      }

                      {

                        this.iconShow['cycle'].show ? this.getIcon({iconName: 'cycle'}): null
                      }
            </tbody></table>
        <div style={{
                width: `100%`,
                height: '20px',
              }}>
        </div>
        </Fragment>
      )
    }

  }
